import request from '@/utils/request'

export const getAllDevices = () => {
  return request.get('/device/get_all_massage_device')
}

export const getUserApts = (userId) => {
  return request.get('/apt/appointments', {
    params: {
      user_id: userId
    }
  })
}
